import ClarityLogo from "@/assets/clarity-logo-light.svg";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
};

/** Fixed top-right Clarity mark — visible across cover and scrolled proposal content (Link B). */
export default function ProposalStickyClarityLogo({ className }: Props) {
  return (
    <div
      className={cn(
        "proposal-no-print pointer-events-none fixed top-6 right-6 z-40 print:hidden sm:top-8 sm:right-[8vw]",
        className,
      )}
      data-testid="proposal-sticky-clarity-logo"
      aria-hidden
    >
      <img
        src={ClarityLogo}
        alt=""
        className="h-7 w-auto object-contain opacity-95 sm:h-8"
        style={{ maxWidth: "11rem" }}
      />
    </div>
  );
}
